const BASE_RECONNECT_DELAY_MS = 1000;
const MAX_RECONNECT_DELAY_MS = 30000;
const MAX_RECONNECT_ATTEMPTS = 10;
const HEARTBEAT_INTERVAL_MS = 15000;
const HEARTBEAT_TIMEOUT_MS = 45000;

const computeReconnectDelay = (attempt, random = Math.random) => {
  const safeAttempt = Math.max(1, attempt);
  const exponentialDelay = Math.min(
    MAX_RECONNECT_DELAY_MS,
    BASE_RECONNECT_DELAY_MS * 2 ** (safeAttempt - 1)
  );
  const jitter = Math.floor(Math.max(0, random()) * 400);
  return exponentialDelay + jitter;
};

const shouldRetryReconnect = (attempts) => attempts < MAX_RECONNECT_ATTEMPTS;

export {
  BASE_RECONNECT_DELAY_MS,
  MAX_RECONNECT_DELAY_MS,
  MAX_RECONNECT_ATTEMPTS,
  HEARTBEAT_INTERVAL_MS,
  HEARTBEAT_TIMEOUT_MS,
  computeReconnectDelay,
  shouldRetryReconnect,
};
